export default __webpack_public_path__ + "static/media/blog-single.20766293.jpg";